import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { AuthService } from '../services/auth.service';

@Component({
  selector: 'dvl-main',
  templateUrl: './main.component.html'
})
export class DvlMainComponent {
  private authState$: Observable<any>;
  private loginMessage: string;

  constructor(public authService: AuthService) {
    this.authState$ = this.authService.isLogged;
  }

  login(form: any) {
    this.authService.login(form.email, form.password)
      .then(() => this.loginMessage = undefined )
      .catch((error) => this.loginMessage = "Email/password inválidos.");
  }

  logout() {
    this.authService.signOut();
  }
}



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/main/main.component.ts